import constants from 'constants/index'

const labelTranslation = (type) => {
  return (
    (type && constants.recurrence.DATE_TRANSLATION_LABEL[type]) || 'indefinido'
  )
}

export default labelTranslation
